import React, { useEffect, useState } from 'react';
import { SkeletonLoader } from './SubscriptionPayment';
import { useModuleContext } from '../../../context/ModuleProvider';
import axiosInstance from '../../../axiosapi';
import moment from 'moment';

export const TestPayment = () => {
  const { url } = useModuleContext();
  const [testPayments, setTestPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getTestPaymentHistory = () => {
    setIsLoading(true);
    axiosInstance
      .get(`${url}/payment/test/list`)
      .then((response) => {
        const paymentData = response.data.payments.map((payment) => ({
          id: payment.id,
          invoiceId: payment.invoiceId,
          amount: payment.amount,
          merchantType: payment.merchantType,
          created_at: new moment(payment.created_at).format('Do MMM YYYY'),
          testName: payment.test && payment.test.name,
        }));
        setTestPayments(paymentData);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error('Error fetching payment history:', error);
      });
  };

  useEffect(() => {
    getTestPaymentHistory();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="d-flex flex-column" style={{ gap: '1rem' }}>
          {Array.from({ length: 3 }).map((_, index) => (
            <SkeletonLoader key={index} />
          ))}
        </div>
      ) : testPayments.length ? (
        testPayments.map((sub, index) => (
          <div key={index} className="subscription-card">
            <div className="header">
              <span className="subscription-id">#{sub.invoiceId}</span>
            </div>
            <p>{sub.created_at}</p>
            <div className="details">
              <div>
                <p className="label">Test</p>
                <p>{sub.testName}</p>
              </div>
              <div>
                <p className="label">Paid Via</p>
                <p>{sub.merchantType}</p>
              </div>
              <div>
                <p className="label">Amount</p>
                <p className="free-amount">Rs.{sub.amount}</p>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="no-subscription">
          <p>No test payment found.</p>
        </div>
      )}
    </>
  );
};

// function SkeletonLoader() {
//   return (
//     <div className="qa-card-skeleton w-100">
//       <div className="header">
//         <div className="user-info">
//           <div className="skeleton name" />
//           <div className="skeleton date" />
//         </div>
//         <div className="skeleton tag" />
//         <div className="skeleton tag" />
//       </div>
//       <div className="skeleton message" />
//       <div className="d-flex" style={{ gap: '1rem' }}>
//         <div className="skeleton images w-50" />
//         <div className="skeleton images w-50" />
//       </div>
//     </div>
//   );
// }
